module.exports = __webpack_public_path__ + "img/6ab03d2.png";